var _path, _path2, _path3, _g, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 19.4596V17.5H23.7501L24.1667 23.75C23.9081 22.2412 21.542 20.9972 20.1054 20.5696C19.6206 20.4253 19.1667 19.9654 19.1667 19.4596Z",
    fill: "#FF791C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 9.16667C14.1667 8.24619 14.9129 7.5 15.8334 7.5H30.0001C32.3013 7.5 34.1667 9.36548 34.1667 11.6667V13.3333C34.1667 15.6345 32.3013 17.5 30.0001 17.5H29.1667C29.4445 18.1944 30.0834 19.8611 30.4167 20.9722C30.7501 22.0833 30.8334 24.6759 30.8334 25.8333L31.6667 25.8333C32.5872 25.8333 33.3334 26.5795 33.3334 27.5V30.8333C33.3334 31.7538 32.5872 32.5 31.6667 32.5H20.0001C19.0796 32.5 18.3334 31.7538 18.3334 30.8333V27.5C18.3334 26.5795 19.0796 25.8333 20.0001 25.8333L24.1667 25.8333C24.1667 25.2546 24.1667 23.75 23.7501 21.6667C23.3334 19.5833 20.8334 17.5 20.8334 17.5H15.8334C14.9129 17.5 14.1667 16.7538 14.1667 15.8333V9.16667Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 21,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 9.16667C14.1667 8.24619 14.9129 7.5 15.8334 7.5H30.0001C32.3013 7.5 34.1667 9.36548 34.1667 11.6667V13.3333C34.1667 15.6345 32.3013 17.5 30.0001 17.5H29.1667C29.4445 18.1944 30.0834 19.8611 30.4167 20.9722C30.7501 22.0833 30.8334 24.6759 30.8334 25.8333L31.6667 25.8333C32.5872 25.8333 33.3334 26.5795 33.3334 27.5V30.8333C33.3334 31.7538 32.5872 32.5 31.6667 32.5H20.0001C19.0796 32.5 18.3334 31.7538 18.3334 30.8333V27.5C18.3334 26.5795 19.0796 25.8333 20.0001 25.8333L24.1667 25.8333C24.1667 25.2546 24.1667 23.75 23.7501 21.6667C23.3334 19.5833 20.8334 17.5 20.8334 17.5H15.8334C14.9129 17.5 14.1667 16.7538 14.1667 15.8333V9.16667Z",
    fill: "#D1CFCD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333C14.1667 17.8731 14.5398 17.5 15.0001 17.5H33.3334C33.7937 17.5 34.1667 17.8731 34.1667 18.3333C34.1667 18.7936 33.7937 19.1667 33.3334 19.1667H15.0001C14.5398 19.1667 14.1667 18.7936 14.1667 18.3333Z",
    fill: "#C6C6C6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 11.6666C9.16675 10.2859 10.286 9.16663 11.6667 9.16663H14.1667V15.8333H11.6667C10.286 15.8333 9.16675 14.714 9.16675 13.3333V11.6666Z",
    fill: "#C6C6C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 12.5C5.83337 12.0397 6.20647 11.6666 6.66671 11.6666H9.16671V13.3333H6.66671C6.20647 13.3333 5.83337 12.9602 5.83337 12.5Z",
    fill: "#5C5B5A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.5,
    width: 3.33333,
    height: 3.33333,
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuTool);
export default __webpack_public_path__ + "static/media/wikiMenuTool.94822d015337a656608ae80e9bb7ea59.svg";
export { ForwardRef as ReactComponent };